/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

const PreferredValidatorTypeLookup = {
  0: "Deposit",
  1: "Withdraw",
  Deposit: 0,
  Withdraw: 1,
} as const;

/**
 * Defines which validator vote account is set during the
 * `SetPreferredValidator` instruction
 */
export const PreferredValidatorType: Omit<
  typeof PreferredValidatorTypeLookup,
  number
> = PreferredValidatorTypeLookup;

export type PreferredValidatorType =
  (typeof PreferredValidatorType)[keyof typeof PreferredValidatorType];

export type PreferredValidatorTypeArgs = PreferredValidatorType;

export function getPreferredValidatorTypeEncoder(): FixedSizeEncoder<PreferredValidatorTypeArgs> {
  return getEnumEncoder(PreferredValidatorType);
}

export function getPreferredValidatorTypeDecoder(): FixedSizeDecoder<PreferredValidatorType> {
  return getEnumDecoder(PreferredValidatorType);
}

export function getPreferredValidatorTypeCodec(): FixedSizeCodec<
  PreferredValidatorTypeArgs,
  PreferredValidatorType
> {
  return combineCodec(
    getPreferredValidatorTypeEncoder(),
    getPreferredValidatorTypeDecoder(),
  );
}
